import React from "react";
import { Button, Tooltip, Typography } from "@mui/material";

/**
 * InquiryButton
 *
 * 「詳細を聞きたい」などの問い合わせボタンを、スマホ・PCで分岐表示する共通コンポーネント。
 * - PC：ボタンをhoverでTooltipを表示
 * - スマホ：ボタン下に説明テキストを表示
 * - ボタンラベル、ツールチップ文言、色味(sx)はpropsでカスタマイズ可
 *
 * @param {boolean} isMobile - モバイル判定
 * @param {function} onClick - ボタン押下時の処理
 * @param {string} label - ボタンのテキスト
 * @param {string} tooltip - Tooltipや説明テキスト
 * @param {object} buttonSx - ボタンのカスタムスタイル
 */
const InquiryButton = ({
  isMobile,
  onClick,
  label = "詳細を聞きたい",
  tooltip = "企業に問い合わせメールが送信されます",
  buttonSx = {},
}) =>
  isMobile ? (
    // ===== スマホ表示時（ボタン＋下に説明テキスト） =====
    <>
      <Button
        variant="contained"
        size="small"
        onClick={onClick}
        sx={{
          fontWeight: "bold",
          background: "linear-gradient(to right, #c084fc, #6366f1)",
          color: "white",
          borderRadius: 999,
          px: 5,
          py: 1,
          fontSize: "0.95rem",
          "&:hover": {
            opacity: 0.9,
            boxShadow: "none",
          },
          width: "100%",
          ...buttonSx, // 色など上書き可能
        }}
      >
        {label}
      </Button>
      {/* 補足説明（下に小さく） */}
      <Typography fontSize="10px" color="gray" mt={0.5}>
        {tooltip}
      </Typography>
    </>
  ) : (
    // ===== PC表示時（ボタンhoverでTooltipを表示、アイコンなし） =====
    <Tooltip title={tooltip} placement="top" arrow>
      <span>
        <Button
          variant="contained"
          size="small"
          onClick={onClick}
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(to right, #c084fc, #6366f1)",
            color: "white",
            borderRadius: 999,
            px: 5,
            py: 1.5,
            fontSize: "0.95rem",
            "&:hover": {
              opacity: 0.9,
              boxShadow: "none",
            },
            width: "auto",
            ...buttonSx, // 色など上書き可能
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );

export default InquiryButton;
